import {
  ENV,
  authFetch,
  parseResponse,
  SUCCESSARRAY,
} from "../utils";

function buildUserFormData(data = {}) {
  const formData = new FormData();

  formData.append("firstname", data.firstname?.trim() || "");
  formData.append("lastname", data.lastname?.trim() || "");
  formData.append("email", data.email?.trim() || "");
  formData.append("role", data.role || "CUSTOMER");
  formData.append("active", data.active !== false ? "true" : "false");

  if (data.number !== undefined && data.number !== null && data.number !== "") {
    formData.append("number", data.number);
  }

  if (data.password) {
    formData.append("password", data.password);
  }

  if (Array.isArray(data.roles)) {
    if (data.roles.length > 0) {
      data.roles.forEach((roleId) => formData.append("roles", roleId));
    } else {
      // FormData no manda ningún campo "roles" si el arreglo va vacío,
      // así que el backend no puede distinguir "quitar todos los roles"
      // de "el campo nunca se envió". Se manda un valor vacío para que
      // sí llegue el campo y el backend pueda vaciar los roles.
      formData.append("roles", "");
    }
  }

  if (data.avatar instanceof File) {
    formData.append("avatar", data.avatar);
  }

  return formData;
}

export class User {
  async getMe() {
    const url = `${ENV.API_URL}/${ENV.ENDPOINTS.USER.USER_ME}`;

    const response = await authFetch(url);
    const result = await parseResponse(response);

    if (!SUCCESSARRAY.includes(response.status)) {
      throw result;
    }

    return result;
  }

  async getUsers(page = 1, limit = 10, filters = {}) {
    const queryParams = new URLSearchParams({
      page,
      limit,
      ...filters,
    });

    const url =
      `${ENV.API_URL}/` +
      `${ENV.ENDPOINTS.USER.USERS}` +
      `?${queryParams.toString()}`;

    const response = await authFetch(url);
    const result = await parseResponse(response);

    if (!SUCCESSARRAY.includes(response.status)) {
      throw result;
    }

    return result;
  }

  async getUser(userId) {
    const url =
      `${ENV.API_URL}/` +
      `${ENV.ENDPOINTS.USER.USER}/` +
      userId;

    const response = await authFetch(url);
    const result = await parseResponse(response);

    if (!SUCCESSARRAY.includes(response.status)) {
      throw result;
    }

    return result;
  }

  async createUser(data) {
    const url = `${ENV.API_URL}/${ENV.ENDPOINTS.USER.USER}`;

    const params = {
      method: "POST",
      body: buildUserFormData(data),
    };

    const response = await authFetch(url, params);
    const result = await parseResponse(response);

    if (!SUCCESSARRAY.includes(response.status)) {
      throw result;
    }

    return result;
  }

  async updateUser(userId, data) {
    const url =
      `${ENV.API_URL}/` +
      `${ENV.ENDPOINTS.USER.USER}/` +
      userId;

    const params = {
      method: "PATCH",
      body: buildUserFormData(data),
    };

    const response = await authFetch(url, params);
    const result = await parseResponse(response);

    if (!SUCCESSARRAY.includes(response.status)) {
      throw result;
    }

    return result;
  }

  async deleteUser(userId) {
    const url =
      `${ENV.API_URL}/` +
      `${ENV.ENDPOINTS.USER.USER}/` +
      userId;

    const params = {
      method: "DELETE",
    };

    const response = await authFetch(url, params);
    const result = await parseResponse(response);

    if (!SUCCESSARRAY.includes(response.status)) {
      throw result;
    }

    return result;
  }
}
